import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Frown, ShoppingBag, UtensilsCrossed } from 'lucide-react';
const painPoints = [{
  icon: <Clock className="h-8 w-8 text-terracotta" data-id="element-148" />,
  text: 'Tienes comida en casa, pero al final del día estás demasiado agotada y estresada para cocinar.'
}, {
  icon: <UtensilsCrossed className="h-8 w-8 text-terracotta" data-id="element-149" />,
  text: 'Quieres servir comidas deliciosas para tu familia, pero el tiempo de preparación que necesitas es más del que tienes.'
}, {
  icon: <ShoppingBag className="h-8 w-8 text-terracotta" data-id="element-150" />,
  text: 'Sales a comer (o pides a domicilio) MUCHO más de lo que quisieras porque simplemente es más fácil que intentar cocinar.'
}, {
  icon: <Frown className="h-8 w-8 text-terracotta" data-id="element-151" />,
  text: 'Odias que te pregunten "¿qué hay de cenar?" porque realmente nunca lo sabes.'
}];
export const PainPoints = () => {
  return <section className="bg-white px-4 py-8 md:py-16 lg:px-8" data-id="element-152">
      <div className="mx-auto max-w-6xl" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-16 text-center" data-id="element-154">
          <h2 className="font-serif text-4xl font-bold text-text-dark md:text-5xl" data-id="element-155">
            Yo he estado ahí.
          </h2>
        </motion.div>

        {/* Grid of Cards */}
        <div className="mb-8 md:mb-16 grid gap-8 md:grid-cols-2" data-id="element-156">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-start space-y-4 rounded-2xl bg-gray-50 p-8 shadow-sm transition-shadow hover:shadow-md" data-id="element-157">
              <div className="rounded-full bg-white p-3 shadow-sm" data-id="element-158">
                {point.icon}
              </div>
              <p className="text-lg leading-relaxed text-text-dark" data-id="element-159">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        {/* Testimonial Image */}
        <div className="mb-8 md:mb-16 mx-auto max-w-lg" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/fGBwVmeT19UCvyf3MTCK2c/testimonio2.png" alt="Testimonio de Ana Martínez" className="w-full rounded-xl shadow-md" data-id="element-161" />
        </div>

        {/* Narrative */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl space-y-6 text-center" data-id="element-162">
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-163">
            Yo era esa mamá. Quería tanto tener la cena lista cada noche porque
            ¿no se supone que eso es lo que debo hacer? Pero honestamente, con
            nuestro estilo de vida tan ajetreado, ¡simplemente no era posible!
          </p>
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-164">
            La hora de la cena es un CAOS. Todos acaban de llegar a casa. Los
            niños están de mal humor y cansados. Rezas para que realmente tengas
            todo lo que necesitas. ¿Quién quiere intentar picar verduras en
            medio de semejante locura?
          </p>
        </motion.div>

        {/* Intensely Tested Recipes Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 md:mt-16 mx-auto max-w-3xl" data-id="element-165">
          <img src="https://cdn.magicpatterns.com/uploads/khc4o1UNL6PthhYVrQ2DsK/3.png" alt="Recetas Rigurosamente Probadas - Solomillo de Cerdo al Romero con Patatas, Lasaña de Pollo Blanca, Sopa Cremosa de Brócoli y Cheddar, Pollo General Tso con Verduras Firmes, Pasta con Carne y Queso Fundido, Sopa Sustanciosa de Carne y Verduras y muchas más" className="w-full rounded-2xl shadow-lg" data-id="element-166" />
        </motion.div>
      </div>
    </section>;
};